import { graphql } from '@/generated/gql';

export const COVERAGE_ASSISTANT_QUERY = graphql(/* GraphQL */ `
  query CommodityUndercoverages(
    $timeframeFrom: DateTime!
    $timeframeTo: DateTime!
    $commodityGroupIds: [UUID!]!
    $organizationIds: [UUID!]!
    $commodityIds: [UUID!]
    $maxResults: Int
    $languageCode: Language!
  ) {
    commodityUndercoverages(
      timeframeFrom: $timeframeFrom
      timeframeTo: $timeframeTo
      commodityGroupIds: $commodityGroupIds
      organizationIds: $organizationIds
      commodityIds: $commodityIds
      maxResults: $maxResults
      languageCode: $languageCode
    ) {
      id
      undercoverages {
        commodityId
        commodityGroupId
        organizationId
        undercoveredQuantity
        unitId
        priceUnit
        validFrom
        validTo
        currency
        minimumOrderQuantity
        qualifiedSupplierIds
        title
        description
      }
      totalCount
      pageSize
    }
  }
`);
